angular.module('unergie.main')
.controller('contractDraftsCtrl', ($scope, $location, $state, AccountService, AlertManager, DataAccess, ApiAdmin, BoFeaturesService, ApiUser, DraftsBasic,
    ReferencesService, TableGeneratorService, ErrorCatcher, FileUploader) => {
    $scope.canBatchDraftEligibility = BoFeaturesService.isFeatureOn('canBatchDraftEligibility')
    $scope.canImportBulkPurchaseTestFile = BoFeaturesService.isFeatureOn('canImportBulkPurchaseTestFile')
    $scope.drafts = {}
    $scope.drafts.refreshing = false
    $scope.drafts.instance = {}
    $scope.drafts.instance.page = () => 1
    $scope.drafts.instance.count = () => 25
    $scope.drafts.instance.sorting = () => ({ modification_ts: 'desc' })
    $scope.drafts.instance.filter = () => _.assign({ status: '!10', initiator_channel: '!CUSTOMER_CHALLENGE_WINTER_2022_2023' }, _.clone($location.search()))

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    $scope.drafts.columns = {
        'id': { label: 'Id', mode: 'search_wildcard', length: 9 },
        'id_account': { label: 'Id account', mode: 'hidden' },
        'customer_id': { label: 'Id client', mode: 'hidden' },
        'status': { label: 'Statut', mode: 'search_operator' },
        'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
        'fullname': { label: 'Nom', mode: 'search_wildcard' },
        'mail': { label: 'Email', mode: 'search_wildcard' },
        'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
        'max_power': { label: 'Puissance', mode: 'search_operator' },
        'id_p_calendar': { label: 'Offre', mode: 'search_wildcard', length: 4 },
        'prm.metter_kind': { label: 'TypeCompteur', mode: 'search_wildcard' },
        'sponsor_id': { label: 'Parrain', mode: 'search_wildcard' },
        'id_ref_promo': { label: 'Code Promo', mode: 'search_wildcard' },
        'rejection_code': { label: 'Code rejet', mode: 'search_wildcard' },
        'prm_search_hint': { label: 'Critère de recherche', mode: 'search_wildcard' },
        'channel': { label: 'Canal', mode: 'filter_only', debounce: 0 },
        'bulk_purchase': { label: 'Achat groupé', mode: 'hidden' },
        'last_eligibility_date': { label: 'Éligibilité effectuée', mode: 'search_wildcard' },
        'overdue_scoring': { label: 'Scoring effectuée', mode: 'search_wildcard' },
        'contact_status': { label: 'Achat groupé', mode: 'search_wildcard' },
        'initiator_channel': { label: 'Canal d initialisation', mode: 'search_wildcard' },
    }

    const transformData = function (data) {
        let lastDate = null
        let alternate = false
        data.forEach((draft) => {
            draft.fullname = ((draft.givenname === null) && (draft.sn === null) && draft.id_anonymous) ? '<anonymous>' : (`${draft.givenname} ${draft.sn}`)
            if ((lastDate === null) || !moment(draft.modification_ts).startOf('day').isSame(lastDate)) {
                alternate = !alternate
                lastDate = moment(draft.modification_ts).startOf('day')
            }
            draft.alternate = alternate
        })
        return data
    }

    const refresh = () => TableGeneratorService.getTable($scope.drafts, 'contractdrafts', 'account,prm,vendor,channel', transformData)

    $scope.refresh = refresh
    refresh()

    $scope.isContinuable = (draft) => [0, 90].includes(draft.status)


    ReferencesService.getRef('contractDraftStatus').then((contractDraftStatusMapping) => {
        const map = []
        _.each(contractDraftStatusMapping, (v, k) => {
            if (k && v && v[0]) {
                map.push({ id: k, label: v })
            }
        })
        $scope.contractMapping = map
    })

    $scope.draftEligibilityBatchPayload = {
        limit: 50,
    }
    $scope.draftEligibilityBatchFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
    }

    $scope.draftEligibilityBatch = () => {
        $scope.draftEligibilityBatching = true
        return ApiAdmin.draftEligibilityBatch($scope.draftEligibilityBatchPayload).$promise.then((result) => {
            AlertManager.success(result.message)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.draftEligibilityBatching = false
        })
    }

    $scope.batchBulkPurchaseContactPayload = {
        bulk_purchase: 'ufc',
        first_contact: true,
        limit: 10,
    }
    $scope.batchBulkPurchaseContactFields = {
        bulk_purchase: {
            label: 'Achat groupé',
            required: true,
            type: 'text',
        },
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
        first_contact: {
            label: 'Premier contact ? (sinon relance)',
            required: true,
            type: 'checkbox',
        },
    }

    $scope.batchBulkPurchaseContact = () => {
        $scope.batchBulkPurchaseContacting = true
        return ApiUser.batchBulkPurchaseContact($scope.batchBulkPurchaseContactPayload).$promise.then((result) => {
            AlertManager.success(result.message)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.batchBulkPurchaseContacting = false
        })
    }

    $scope.openDraft = (draft) => {
        return Promise.resolve().then(() => {
            return DraftsBasic.getDraftBasicIdForDraftElec({ id: draft.id }).$promise
            .then((result) => {
                return result.id_draft_basic
            })
            .catch(ErrorCatcher)
        })
        .then((idDraft) => {
            const url = $state.href('salesTunnelV3', { draft: idDraft })
            window.open(url, '_blank')
        })
    }

    // UPLOADER
    $scope.bulkPurchaseTestFileUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [{ bucketName: 'files', path: 'bulk_purchase/ufc/in' }],
        autoUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier de test d'achat groupé importé`)
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.isActive = (state) => $state.is(state)
})
